// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Translation from "common/src/bindings/Translation.bs.js";
import Button from "@mui/material/Button";
import ViewList from "@mui/icons-material/ViewList";
import ViewModule from "@mui/icons-material/ViewModule";

function ListGridSelect(Props) {
  var isListMode = Props.isListMode;
  var setIsListMode = Props.setIsListMode;
  var t = Translation.useT(/* Common */0);
  return React.createElement("div", {
              className: "flex"
            }, React.createElement("div", undefined, React.createElement(Button, {
                      startIcon: React.createElement(ViewModule, {}),
                      onClick: (function (param) {
                          return Curry._1(setIsListMode, (function (param) {
                                        return false;
                                      }));
                        }),
                      variant: "text",
                      color: isListMode ? "inherit" : "primary",
                      children: t("Grid")
                    })), React.createElement("div", {
                  className: "pl-3"
                }, React.createElement(Button, {
                      startIcon: React.createElement(ViewList, {}),
                      onClick: (function (param) {
                          return Curry._1(setIsListMode, (function (param) {
                                        return true;
                                      }));
                        }),
                      variant: "text",
                      color: isListMode ? "primary" : "inherit",
                      children: t("List")
                    })));
}

var make = ListGridSelect;

export {
  make ,
  
}
/* react Not a pure module */
